import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrencyFieldText } from 'src/components/mui-overrides/Currency';

interface Props {
  disabled?: boolean;
}

export const PublicFundingField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  const formik = useFormikContext();

  return (
    <CurrencyFieldText
      disabled={disabled}
      hideHelperText={true}
      label={t('dashboard.assets.addedit.investment.issuingdetails.fields.publicFunding')}
      fieldName="investmentDetails.publicFunding"
      formik={formik}
      currency={'€'}
    />
  );
};
